import { CommonModule } from '@angular/common';
import { Component, inject, signal, WritableSignal } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../../auth/services/auth.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { SideBarMenuService } from './service/side-bar-menu.service';
import { Menu } from './interface/menu-interface';
import { User } from '../../../auth/interfaces/user-interface';
declare var bootstrap: any;

@Component({
  selector: 'app-side-bar-menu',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './side-bar-menu.component.html',
  styleUrls: ['./side-bar-menu-component.css'],
})
export class SideBarMenuComponent {
  bootstrap: any
  isCollapsed: WritableSignal<boolean>;
  user: User | null = null;
  constructor(    
    public menuService: SideBarMenuService,
    public authService: AuthService,
    public commonService: CommonService, public router: Router) {
      this.isCollapsed = signal(this.commonService.getCollapse());
  }

  ngOnInit() {
    this.menuService.getMenu();
    this.user = this.authService.getUser();
  }

  ngAfterViewInit() {
    this.initTooltips();
  }

  ngAfterViewChecked() {
    this.initTooltips();
  }

  /**
  * Devuelve la primera letra del nombre del usuario en mayúscula.
  */
  get userFirstLetter(): string {
    return this.user && this.user.nombre ? this.user.nombre.charAt(0).toUpperCase() : '';
  }

  private initTooltips() {
    if (this.isCollapsed()) {
      const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.forEach((tooltipTriggerEl: any) => {
        let instance = bootstrap.Tooltip.getInstance(tooltipTriggerEl);
        if (!instance) {
          instance = new bootstrap.Tooltip(tooltipTriggerEl);
        }
      });
    } else {
      // Oculta los tooltips activos al expandir el sidebar
      const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.forEach((tooltipTriggerEl: any) => {
        const instance = bootstrap.Tooltip.getInstance(tooltipTriggerEl);
        if (instance) {
          instance.dispose();
        }
      });
    }
  }

  toggleSidebar() {
    this.isCollapsed.set(!this.isCollapsed());
    this.commonService.setCollapse(this.isCollapsed());
    setTimeout(() => this.initTooltips(), 0);
  }


  expand(menu: Menu, event?: MouseEvent) {
    menu.expanded = !menu.expanded;
    this.hideAllTooltips();
  }

  logout(event?: MouseEvent) {
    this.hideAllTooltips();
    this.authService.logout();
    this.router.navigateByUrl('/auth/login');
  }

  /**
   * Muestra el tooltip del menú cuando el sidebar está colapsado y el mouse entra.
   * Oculta los tooltips de otros elementos y muestra solo el del elemento actual.
   * @param event Evento de mouse (MouseEvent) sobre el elemento del menú.
   */
  onMenuMouseEnter(event: MouseEvent) {
    if (this.isCollapsed()) {
      const target = event.currentTarget as HTMLElement;
      // Oculta todos los tooltips excepto el actual
      const allTooltips = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      allTooltips.forEach((el: any) => {
        if (el !== target) {
          const inst = bootstrap.Tooltip.getInstance(el);
          if (inst) {
            inst.hide();
          }
        }
      });
      let instance = bootstrap.Tooltip.getInstance(target);
      if (!instance) {
        instance = new bootstrap.Tooltip(target);
      }
      instance.show();
    }
  }

  /**
   * Oculta el tooltip del menú cuando el mouse sale del elemento, solo si el sidebar está colapsado.
   * @param event Evento de mouse (MouseEvent) sobre el elemento del menú.
   */
  onMenuMouseLeave(event: MouseEvent) {
    if (this.isCollapsed()) {
      const target = event.currentTarget as HTMLElement;
      const instance = bootstrap.Tooltip.getInstance(target);
      if (instance) {
        instance.hide();
      }
    }
  }

  /**
  * Oculta todos los tooltips activos del sidebar.
  */
  hideAllTooltips() {
    const allTooltips = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    allTooltips.forEach((el: any) => {
      const inst = bootstrap.Tooltip.getInstance(el);
      if (inst) {
        inst.hide();
      }
    });
  }
}
